/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
// import { ASSETS_TABLE } from "../pages/ListedAssetsTable/graphql/listed-asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {
    FEEDBACK_BUTTON,
    PRODUCT,
    PRODUCT_IMG,
    MODAL_FEEDBACK_CARD,
    PROMO_BUTTON,
    PROVENANCE,
} from "./config/product-view";
import { GET_PRODUCT } from "../pages/MainPage/graphql/get-products.query";
import { GET_PRODUCT_DETAIL } from "../pages/MainPage/graphql/get-product-detail.query";
import moment from "moment";

const SERVICE_NAME = "product-view.service";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ProductViewService {
    name = SERVICE_NAME;
    private static instance: ProductViewService;

    private constructor() {
        this.report();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new ProductViewService();
        }
        return this.instance;
    }

    _getImages(images: any) {
        let resultImg: any[] = [];
        images &&
            Array.isArray(images) &&
            images.forEach((item: any, index: number) => {
                if (item)
                    resultImg.push({
                        original: item,
                        thumbnail: item,
                        thumbnailHeight: "100",
                        thumbnailClass: "image-thumb",
                    });
            });
        return resultImg;
    }

    async productview(payload: string) {
        log.info(`in productView service.`, payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_PRODUCT,
                    variables: {
                        appMode: "web",
                        barcode: payload,
                    },
                    fetchPolicy: "network-only",
                });
                log.blue(`Products in service:`, res?.data?.getV2Provenance);
                let _data = res?.data?.getV2Provenance?.v2ProvData;
                if (_data)
                    return {
                        v2ProvData: _data,
                        FEEDBACK_BUTTON: _data?.FeedbackButton,
                        PRODUCT: {
                            ...{ ..._data?.product },
                        },
                        PRODUCT_IMG: this._getImages(_data?.product?.images),
                        MODAL_FEEDBACK_CARD: {
                            ...{ ..._data?.feedbackModal },
                        },
                        PROMO_BUTTON: {
                            ...{ ...PROMO_BUTTON },
                            url: _data?.product?.webUrl,
                        },
                        PROVENANCE: {
                            ...{ ..._data?.provenance },
                        },
                        ALL_PROV_STEP_MAP: _data?.allProvStepMap,
                        GTIN: _data?.product?.gtin,
                        BATCH: _data?.product?.batch,
                        PROMO_VIDEO_URL: {
                            url: _data?.product?.promoVideoUrl,
                            // url: "https://www.youtube.com/watch?v=Ct6-ZK0Z9mo"
                        },
                    };
            }
        } catch (err) {}
    }

    _getMeta = (data: any[]) => {
        let res =
            data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data.map((item: any, index: number) => {
                return {
                    key: item?.label,
                    value: item?.value,
                };
            });
        return res;
    };

    _productData = (data: any, detailsData: any) => {
        let _meta: any[] = this._getMeta(
            detailsData?.ProductDetailInfo?.productInfoList
        );
        let _secondaryMeta: any[] = this._getMeta(
            detailsData?.OrganizationInfo?.organizationInfoList
        );
        let _actions: any[] =
            data && data?.promoVideoUrl
                ? [
                      {
                          key: "provenance",
                          title: "Provenance Journey",
                      },
                      {
                          key: "feedback",
                          title: "Feedback",
                      },
                      {
                          key: "visit",
                          title: "Visit",
                          url: data?.webUrl,
                      },
                      {
                          key: "video",
                          title: "Watch Video",
                          url: data?.webUrl,
                      },
                      // {
                      //     key: "details",
                      //     title: "View Proof of Authenticity",
                      // },
                  ]
                : [
                      {
                          key: "provenance",
                          title: "Provenance Journey",
                      },
                      {
                          key: "feedback",
                          title: "Feedback",
                      },
                      {
                          key: "visit",
                          title: "Visit",
                          url: data?.webUrl,
                      },
                      // {
                      //     key: "details",
                      //     title: "View Proof of Authenticity",
                      // },
                  ];
        return {
            idx: "1",
            title: data?.title,
            subtitle: data?.subtitle,
            secondaryTitle: detailsData?.OrganizationInfo?.title,
            promoVideoUrl: {
                url: data?.promoVideoUrl,
                // url: "https://www.youtube.com/watch?v=Ct6-ZK0Z9mo",
            },
            serialNo: "Rare #/1",
            img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            tag: "DIAMOND",
            productCategory: "collectibles",
            category: "diamond",
            price: [
                {
                    type: "price",
                    amount: data?.priceValue,
                },
            ],
            createdBy: {
                userName: detailsData?.OrganizationInfo?.aboutOrgInfo,
                userId: detailsData?.OrganizationInfo?.aboutOrgInfo,
                link: "https://www.diageoindia.com/",
                authProofUrl: "",
            },
            meta: [
                ..._meta,
                {
                    key: data?.priceKey,
                    value: data?.priceValue,
                },
                {
                    key: data?.qtyKey,
                    value: data?.qtyValue,
                },
                {
                    key: "Batch",
                    value: data?.batch,
                },
                {
                    key: data?.serialKey,
                    value: data?.serialValue,
                },
            ],
            secondaryMeta: [..._secondaryMeta],

            actions: _actions,
            images: this._getImages(data?.images),
        };
    };

    async productDetailView(payload: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_PRODUCT_DETAIL,
                    variables: {
                        gtinKey: payload?.gtin,
                        barcode: payload?.id,
                    },
                    fetchPolicy: "network-only",
                });
                log.blue(
                    `product detaul in service:`,
                    res?.data?.getDecodedProduct
                );
                let _detailsData =
                    res?.data?.getDecodedProduct?.data?.productDetails;
                let _data = payload?.v2ProvData;
                let firstProv =
                    _data?.provenance?.data &&
                    Array.isArray(_data?.provenance?.data) &&
                    _data?.provenance?.data.length > 0 &&
                    _data?.provenance?.data[0];
                firstProv =
                    firstProv?.data &&
                    Array.isArray(firstProv?.data) &&
                    firstProv?.data.length > 0 &&
                    firstProv?.data[0];
                if (_data)
                    return {
                        // pagination: {
                        //     nextOffset: offset + _found.length,
                        //     totalItems: TEST_DATA?.length,
                        // },
                        ...this._productData(_data?.product, _detailsData),
                        firstProv: firstProv,
                        MODAL_FEEDBACK_CARD: {
                            ...{ ..._data?.feedbackModal },
                        },
                        GTIN: _data?.product?.gtin,
                        BATCH: _data?.product?.batch,
                    };
                // if (_data)
                //     return {
                //         PRODUCT_IMG: this._getImages(
                //             _data?.ProductImages?.productImages
                //         ),
                //         ORGANIZATION_INFO: _data?.OrganizationInfo,
                //         PRODUCT_DETAIL_INFO: _data?.ProductDetailInfo,
                //         PRODUCT_TITLE_CARD: _data?.ProductTitleCard
                //     };
            }
            // let _data = {
            //     PRODUCT_IMG,
            //     ORGANIZATION_INFO,
            //     PRODUCT_DETAIL_INFO,
            //     PRODUCT_TITLE_CARD,
            // };
            // return _data;
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
